import { MathText } from '@/features/content/MathText';

import styles from './ExactAnswerEditor.module.css';

interface ExactAnswerEditorProps {
  answerUnits?: string;
  disabled?: boolean;
  exactAnswer?: string;
  structuralEditsRestricted?: boolean;
  useRandomVariables?: boolean;
  variableBasedAnswer?: string;
  onChange: (updates: {
    answerUnits?: string;
    exactAnswer?: string;
    variableBasedAnswer?: string;
  }) => void;
}

export function ExactAnswerEditor({
  answerUnits,
  disabled = false,
  exactAnswer,
  useRandomVariables = false,
  variableBasedAnswer,
  onChange,
}: ExactAnswerEditorProps) {
  return (
    <div className={styles.root}>
      <div className={styles.inlineFields}>
        {useRandomVariables ? (
          <label className={styles.answerField}>
            <span className={styles.label}>Variable-Based Answer</span>
            <input
              className={styles.input}
              disabled={disabled}
              onChange={(event) => {
                onChange({
                  variableBasedAnswer: event.target.value,
                });
              }}
              type="text"
              value={variableBasedAnswer ?? ''}
            />
          </label>
        ) : (
          <label className={styles.answerField}>
            <span className={styles.label}>Correct Answer</span>
            <input
              className={styles.input}
              disabled={disabled}
              onChange={(event) => {
                onChange({
                  exactAnswer: event.target.value,
                });
              }}
              type="text"
              value={exactAnswer ?? ''}
            />
          </label>
        )}

        <label className={styles.unitsField}>
          <span className={styles.label}>Answer Units</span>
          <input
            className={styles.input}
            disabled={disabled}
            onChange={(event) => {
              onChange({
                answerUnits: event.target.value,
              });
            }}
            type="text"
            value={answerUnits ?? ''}
          />
        </label>
      </div>

      {answerUnits?.trim() ? (
        <div className={styles.preview}>
          <MathText text={answerUnits} />
        </div>
      ) : null}
    </div>
  );
}
